import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, first, toObservable,nullsafe } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { GuiaListMem } from "app/features/general/operativa/items/guias/listados/guias/list/listmem";
import { FiltroConsultaZEComponent } from "./filtro";

type Entity = models.FiltroConsultaZE;

export interface Props {
    session: models.Session;
    value: Entity;
    onChange: (x: Entity) => void;
}

function filtroValido(x: Entity): boolean {
    return x.fecha != null && x.idVehiculoZE != null;
}

function obtenerServAdicionalesGuia(x: models.ServiciosAdicionalesGuiaDTO | null): string[] {
    if(!x) return [];
    
    const ret = [
        x.EntregaDomicilio ? "Entrega a domicilio" : undefined,
        x.RecoleccionDomicilio ? "Recolección a domicilio" : undefined,
        x.TipoAcuse == models.TipoAcuse.Interno ? "Acuse interno" : undefined,
        x.TipoAcuse == models.TipoAcuse.Externo ? `Acuse externo (${x.NombreRequerimientoAcuse})` : undefined,
    ];
    return ret.filter(x => x != null).map(x => x!);
}

export const columnasFijas: kea.Grid2Column<models.GuiaDTO>[] = [
    /*
    { title: "   Folio   ", cell: x => ({ 
        data: x.Folio, view: () =>
            <span style={{ fontFamily: "monospace" }} >
                {//x.Folio}{<span className="label label-warning" >ZE</span>
                }
            </span>
    }) },
    */
{ title: "Folio", cell: x => ({ data: x.Folio }) },
{ title: "Factura", cell: x => ({ data: x.FolioFactura }) },
{ title: "Cancelada", cell: x => ({ data: x.EsCancelada }) },
{ title: "Status", cell: x => ({ data: models.StatusGuia[x.Status] }) },
{ title: "Sucursal actual", cell: x => ({ data: x.Posicion }) },
{ title: "Fecha creación", cell: x => ({ data: kea.toDate(x.FechaCreacion) }) },
{ title: "Cliente origen", cell: x => ({ data: x.NombreClienteOrigen }) },
{ title: "Origen", cell: x => ({ data: x.DireccionOrigenDTO && x.DireccionOrigenDTO.Descripcion }) },
{ title: "Suc origen", cell: x => ({ data: x.NombreSucursalOrigen }) },
{ title: "Cliente destino", cell: x => ({ data: x.NombreClienteDestino }) },
{ title: "Destino", cell: x => ({ data: x.DireccionDestinoDTO && x.DireccionDestinoDTO.Descripcion }) },
{ title: "Suc destino", cell: x => ({ data: x.NombreSucursalDestino }) },
{ title: "Paquetes", cell: x => ({ data: (x.DescripcionPaquetesVolumen || "").split(", ") }) },
{ title: "Paquetes (detalle)", cell: x => ({ data: (x.DescripcionPaquetesTexto || "").split(", ") }) },
{ title: "Cantidad Paquetes", cell: x => ({ data: x.CantidadPaquetes }) },
{ title: "Sobres", cell: x => ({ data: x.CantidadSobres }) },
{ title: "Distancia flete (km)", cell: x => ({ data: x.DistanciaFlete }) },
{ title: "Serv. adic.", cell: x => ({ data: obtenerServAdicionalesGuia(x.ServiciosAdicionales) }) },
{ title: "Ruta de EAD", cell: x => ({ data: x.NombreRutaEntregaDomicilio }) },
{ title: "Flete por cobrar", cell: x => ({ data: x.FletePorCobrar }) },
{ title: "Pagada", cell: x => ({ data: x.Pagada }) },
{ title: "A crédito", cell: x => ({ data: x.EsDeCredito }) },
{ title: "Importe total", cell: x => ({ data: x.Importes ? x.Importes.Total : "", view: x.Importes ? kea.formatCurrency : undefined }) },
{ title: "Otros importes", cell: x => ({ data: x.Importes }) },
{ title: "Requiere contacto autorizado", cell: x => ({ data: x.RequiereContactoAutorizado }) },
{ title: "Contacto recibio", cell: x => ({ data: x.NombreContactoRecibio }) },
{ title: "Es de acuse", cell: x => ({ data: x.EsDeAcuse }) },
{ title: "Folio acuse original", cell: x => ({ data: x.FolioGuiaAcuse }) },
{ title: "Fecha de entrega", cell: x => ({ data: kea.toDate(x.FechaEntrega) }) },
{ title: "Fecha de facturación", cell: x => ({ data: kea.toDate(x.FechaDeFacturacion) }) },
{ title: "Fecha de poliza contable", cell: x => ({ data: kea.toDate(x.FechaDePoliza) }) },
{ title: "Fecha de pago", cell: x => ({ data: kea.toDate(x.FechaDePago) }) },
{ title: "Usuario documentó", cell: x => ({ data: x.NombrePersonaDocumento }) },
{ title: "Usuario entregó", cell: x => ({ data: x.NombrePersonaEntrego }) },
{ title: "Tipo de seguro", cell: x => ({ data: nullsafe(x.TipoSeguro, x => models.TipoSeguroGuia[x]) }) },
{ title: "Valor declarado", cell: x => ({ data: x.ValorDeclarado }) },
{ title: "Motivo rechazo", cell: x => ({ data: x.MotivoRechazo }) },
{ title: "Fecha límite de facturación", cell: x => ({ data: kea.toDate(x.FechaLimiteFacturacion) }) },
{ title: "Tarifa", cell: x => ({ data: x.NombreTarifa }) },
{ title: "Observaciones", cell: x => ({ data: (x.ObservacionesGuia || "").split("|") }) },
{ title: "RFC cliente paga", cell: x => ({ data: x.RfcClientePaga }) },
{ title: "Zona ext.", cell: x => ({ data: x.NombreZonaExtendida }) },
{ title: "Motivo de rechazo de público general", cell: x => ({ data: x.MotivoRechazoPublicoGeneral }) },



];

export function columnas() {
    const ret: kea.Grid2Column<models.GuiaDTO>[] = [
         kea.columnaBotones([{
            onClick: x => history.go("/operativa/guias/" + x.Folio),
            tooltip: "Ver",
            iconClass: fa("eye"),
        }
         ]),
        ...columnasFijas
    ];
    return ret;
}

export class ConsultaVehiculoZENoRX extends React.PureComponent<Props> {

    verBotonImprimirManifiesto = (x: Props) => x.session.Permisos.CargaZE.VerBotonImprimirManifiesto;

    value = (props: Props) => props.value;
    valido = createSelectorRx(this.value, filtroValido);
    guias = createSelectorRx(this.value, this.valido, (filtro, valido) => 
    valido ? observeResource(resources.CargaZE.GuiasEnVehiculo, filtro.idVehiculoZE, filtro.fecha) : toObservable([]));

    render() {

        if (this.props.session.IdUsuarioZE != null) {
            this.props.value.idUsuarioZE = this.props.session.IdUsuarioZE
        }

        if (this.props.session.IdVehiculoZE != null && this.props.session.IdChoferZE != null && this.props.session.IdUsuarioZE != null) {
            this.props.value.idVehiculoZE = this.props.session.IdVehiculoZE
            this.props.value.idUsuarioZE = this.props.session.IdUsuarioZE
        }
        
        const guias = this.guias(this.props);
        const cols = columnas();
        const filtro = this.value(this.props);
        const verBotonImprimirManifiesto = this.verBotonImprimirManifiesto(this.props);
        return (
            <div>
                <kea.Title titulo="Consulta de guias en vehículo de ZE" onRegresar={() => history.go("../")} >
                </kea.Title>
                <FiltroConsultaZEComponent session={ this.props.session } value={filtro} onChange={this.props.onChange} />
                {/* <GuiaListMem value={guias} /> */}
                <kea.Grid2 items={guias} columnas={cols} cookieKey="ConsultaGuiasZE" />
            </div>
        )
    }
}

export const ConsultaVehiculoZERX = componentToRx(ConsultaVehiculoZENoRX);

export interface State {
    value: Entity;
}

export class ConsultaVehiculoZE extends React.PureComponent<{}, State> {
    constructor(props) {
        super(props);
        this.state = {
            value: {
                fecha: new Date()
            } as Entity
        };
    }

    value = (state: State) => state.value;
    onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: value }, resolve));

    render() {
        const value = this.value(this.state);
        if( value.fecha != null )        
        {
            value.fecha.setHours(23);
            value.fecha.setMinutes(59);
            value.fecha.setSeconds(59);
        }

        return (
            <ConsultaVehiculoZERX
                value={value}
                onChange={this.onChange}
                session = { resources.User.SessionRx }
            />
        )
    }
}




// WEBPACK FOOTER //
// ./app/features/general/operativa/items/consultaZE/index.tsx